import { ColorEnum } from '@/constants/color'
import { isWeb } from '@/constants/environment'
import { changeSearchOpen } from '@/features/pos/components/ProductCatalog/utils/changeSearchOpen'
import { changeSearchProduct } from '@/features/pos/components/ProductCatalog/utils/changeSearchProduct'
import ClearButton from '@/features/pos/components/SearchProductField/parts/ClearButton'
import { useSearchProduct } from '@/features/pos/hooks/search-product/useSearchProduct'
import IconButton from '@/features/ui/buttons/components/IconButton'
import ChevronDownIcon from '@/features/ui/icons/components/ChevronDownIcon'
import SearchIcon from '@/features/ui/icons/components/SearchIcon'
import InputField from '@/features/ui/inputs/components/InputField'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

interface SearchProductFieldProps {
    autoFocus?: boolean
}

const SearchProductField: FC<SearchProductFieldProps> = ({ autoFocus }) => {
    const searchProduct = useSearchProduct()

    const { t } = useTranslation()

    const webFocusResetStyle = isWeb
        ? ({
              outlineStyle: 'none',
              outlineWidth: 0,
              outlineColor: 'transparent',
          } as never)
        : undefined

    return (
        <InputField
            autoFocus={autoFocus}
            placeholder={t('pos.searchProduct')}
            value={searchProduct}
            onChange={changeSearchProduct}
            FrontComponent={<SearchIcon fill={ColorEnum.GRAY_300} height={16} width={16} />}
            TailComponent={
                searchProduct ? (
                    <ClearButton />
                ) : (
                    <IconButton
                        Icon={ChevronDownIcon}
                        mode="rounded"
                        size={24}
                        iconSize={16}
                        onPress={() => changeSearchOpen(false)}
                    />
                )
            }
            inputStyle={[{ paddingHorizontal: 0 }, webFocusResetStyle]}
            style={{ flex: 1, width: '100%', paddingHorizontal: 16 }}
        />
    )
}

export default memo(SearchProductField)
